import serviceAreas from '../config/service_areas.json';

const ALLOWED_SET = new Set(serviceAreas.allowed_zips);

/**
 * Validate ZIP code format (5-digit US ZIP)
 */
export function isValidZipFormat(zip) {
  return /^\d{5}$/.test(zip);
}

/**
 * Check if a ZIP code is in the allowed service area whitelist.
 *
 * @param {string} customerZip - 5-digit ZIP code
 * @returns {{ allowed: boolean, reason: string }}
 */
export function isInServiceArea(customerZip) {
  if (!customerZip || !isValidZipFormat(customerZip)) {
    return { allowed: false, reason: 'invalid_zip' };
  }

  if (ALLOWED_SET.has(customerZip)) {
    return { allowed: true, reason: 'ok' };
  }

  return { allowed: false, reason: 'outside_service_area' };
}
